"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackDestinationsSearchResult = void 0;
const components_common_autocomplete_1 = require("@hotelplan/components.common.autocomplete");
const libs_tracking_1 = require("@hotelplan/libs.tracking");
const TravelDestination_mappers_1 = require("./TravelDestination.mappers");
const trackDestinationsSearchResult = (data, text) => {
    var _a, _b;
    const destinations = (_a = data === null || data === void 0 ? void 0 : data.destinations) === null || _a === void 0 ? void 0 : _a.map(TravelDestination_mappers_1.mapTravelDestinationObjectToCanonical);
    const currentPage = ((_b = data === null || data === void 0 ? void 0 : data.page) === null || _b === void 0 ? void 0 : _b.pageNumber) || 0;
    const nextPage = (0, components_common_autocomplete_1.getNextPage)(destinations, data === null || data === void 0 ? void 0 : data.page);
    const first = currentPage === 0;
    const hasMore = nextPage !== 0;
    (0, libs_tracking_1.trackTravelDestinations)({
        type: libs_tracking_1.TravelDestinationsEventType.TRAVEL_DESTINATIONS_RESULTS,
        payload: {
            suggestions: destinations.map(TravelDestination_mappers_1.mapCanonicalDestinationToTrackableDestination),
            first,
            hasMore,
            text,
        },
    });
};
exports.trackDestinationsSearchResult = trackDestinationsSearchResult;
//# sourceMappingURL=TravelDestination.tracking.js.map